<template>
  <v-dialog
    v-model="show"
    max-width="400"
    @keydown.esc="close"
    @click:outside="close"
    content-class="quick-unit-search-dialog"
    transition="dialog-transition"
    role="dialog"
    aria-modal="true"
    aria-labelledby="quick-search-title"
  >
    <v-card :loading="loading">
      <v-card-text>
        <v-text-field
          ref="unitInput"
          v-model="unitNumber"
          label="Jump to unit"
          :rules="[rules.required, rules.pattern]"
          :error-messages="errorMessage"
          :loading="loading"
          @input="handleInput"
          @keyup.enter="submit"
          maxlength="4"
          pattern="[A-Za-z0-9]*"
          placeholder="Enter 4-character truck number"
          autofocus
          outlined
          :error="!!errorMessage"
        ></v-text-field>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'QuickUnitSearch',
  data() {
    return {
      show: false,
      unitNumber: '',
      errorMessage: '',
      rules: {
        required: value => !!value || 'Please enter a truck number',
        pattern: value => !value || /^[A-Za-z0-9]*$/.test(value) || 'Only letters and numbers allowed'
      },
      loading: false,
      previousActiveElement: null
    };
  },
  methods: {
    open() {
      this.previousActiveElement = document.activeElement;

      this.show = true;
      this.unitNumber = '';
      this.errorMessage = '';

      this.$nextTick(() => {
        this.$refs.unitInput.focus();
      });
    },
    close() {
      this.show = false;
      this.unitNumber = '';
      this.errorMessage = '';

      // Return focus to the previously focused element
      this.$nextTick(() => {
        if (this.previousActiveElement) {
          this.previousActiveElement.focus();
          this.previousActiveElement = null;
        }
      });
    },
    handleInput(value) {
      this.errorMessage = '';

      if (value && !/^[A-Za-z0-9]*$/.test(value)) {
        this.errorMessage = 'Only letters and numbers allowed';
        return;
      }

      // Auto-submit when 4 valid characters are entered
      if (value.length === 4) {
        this.submit();
      }
    },
    async submit() {
      if (!this.unitNumber || this.unitNumber.length !== 4) {
        this.errorMessage = 'Please enter a 4-character truck number';
        return;
      }

      try {
        this.loading = true;
        const unitId = await this.$unitSearch.getIdByNumber(this.unitNumber);

        if (unitId) {
          try {
            await this.$router.push(`/units/${unitId}`);
            this.close();
          } catch (navError) {
            this.errorMessage = 'Error navigating to unit details';
          }
        } else {
          this.errorMessage = `Unit "${this.unitNumber}" not found`;
          this.$refs.unitInput.focus();
        }
      } catch (error) {
        if (error.response && error.response.status === 404) {
          this.errorMessage = `Unit "${this.unitNumber}" not found`;
        } else {
          this.errorMessage = 'Error searching for unit. Please try again.';
        }
        this.$refs.unitInput.focus();
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.quick-unit-search-dialog {
  position: fixed;
  top: 30%;
  margin: auto;
}

.dialog-transition-enter-active,
.dialog-transition-leave-active {
  transition: opacity 0.2s ease-in-out;
}

.dialog-transition-enter,
.dialog-transition-leave-to {
  opacity: 0;
}

.v-card {
  transition: all 0.2s ease-in-out;

  &.v-card--loading {
    pointer-events: none;
    user-select: none;
  }
}
</style>
